import styled from "styled-components";
import { primaryActive } from "../../typography/alpha";

export const DropdownMenu = styled.ul`
  min-width: 100%;
  margin: 0px;
  padding: 0px;
  border-radius: var(--size-border-radius-small);
  background: var(--color-neutral-000-full);
  box-shadow: var(--elevation-4);
  list-style-type: none;

  li {
    display: flex;
    align-items: center;
    cursor: pointer;
    height: 32px;
    padding: 0px 8px;
    white-space: nowrap;
    ${primaryActive.body3};
    :hover {
      background: var(--color-secondary-200);
    }
    :first-of-type {
      border-top-left-radius: var(--size-border-radius-small);
      border-top-right-radius: var(--size-border-radius-small);
    }
    :last-of-type {
      border-bottom-left-radius: var(--size-border-radius-small);
      border-bottom-right-radius: var(--size-border-radius-small);
    }
  }
`;
